module.exports = __webpack_public_path__ + "static/media/216.c31558bb.webp";